import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Box, Popover, Typography } from '@mui/material';

const useSideMenuHoverPopover = (label: string, isExpanded: boolean) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const location = useLocation();

  useEffect(() => {
    setAnchorEl(null);
  }, [location.pathname]);

  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    if (isExpanded) return;
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setAnchorEl(null);
  };

  const hoverPopover = (
    <Popover
      open={Boolean(anchorEl) && !isExpanded}
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
      transformOrigin={{ vertical: 'center', horizontal: 'left' }}
      disableRestoreFocus
      disableAutoFocus
      disableEnforceFocus
      sx={{ pointerEvents: 'none' }}
      PaperProps={{
        elevation: 0,
        sx: {
          borderRadius: '0.75rem',
          bgcolor: '#fefefe',
          boxShadow: '0px 1px 8px 0px rgba(0, 0, 0, 0.15)',
          width: '14.75rem',
          ml: '1rem',
          pointerEvents: 'auto',
        },
        onMouseLeave: handleMouseLeave,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
          height: '2.5625rem',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            height: '1.8125rem',
            transform: 'rotate(-0.04deg)',
            padding: '0.5rem 0.75rem',
            alignItems: 'center',
            gap: '0.6875rem',
            borderRadius: '0.625rem',
          }}
        >
          <Typography
            sx={{
              color: 'grey.800',
              fontSize: '0.8125rem',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: 1.6,
              whiteSpace: 'nowrap',
            }}
          >
            {label}
          </Typography>
        </Box>
      </Box>
    </Popover>
  );

  return {
    handleMouseEnter,
    handleMouseLeave,
    hoverPopover,
    closePopover: () => setAnchorEl(null),
  };
};

export default useSideMenuHoverPopover;
